import { useLanguage } from '@hooks/useLanguage';

export function useIsOneOfSpecifiedLanguages(...languages: string[]) {
  const currentLanguage = useLanguage();
  
  return languages.includes(currentLanguage);
}
